import {api, urls} from '@/api'
import * as types from '@/store/mutation-types'

const getInitialState = () => ({
  catId: null,
  publications: [],
  page: 1,
  per_page: 50,
  ads: [],
  totalPages: null,
  totalPubs: null,
  breadcrumb: []
})

const state = getInitialState()

const actions = {
  fetchPublications: ({commit, state, rootState}, params) => {
    if (params.page) commit(types.SET_CAT_PAGE, params.page)
    else params.page = state.page

    params.per_page = state.per_page
    if (!params.distance && params.distance !== 0) params.distance = rootState.search.distance

    if (params.category) commit(types.SET_CAT_ID, params.category)

    return new Promise((resolve, reject) => {
      api.get(urls.publicationSearch, { params }).then(({data}) => {
        commit(types.SET_CAT_PUBS, data.data)
        commit(types.SET_CAT_TOTAL_PAGES, data.meta.pagination.total_pages)
        commit(types.SET_CAT_TOTAL_PUBS, data.meta.pagination.total)
        commit(types.SET_CAT_BREADCRUMB, data.breadcrumb)
        resolve(data);
      }).catch((error) => {
        reject(error);
      })
    })
  },

  fetchAds: ({commit}, params) => {
    const id = params.category
    delete params.category
    params.per_page = 100

    return api.get(`${urls.ads}/categories/${id}`, { params })
      .then(({data}) => {
        commit(types.SET_CAT_ADS, data.data)
      })
  },

  setPage: ({commit}, page) => { commit(types.SET_CAT_PAGE, page) },

  setTotalPages: ({commit}, total) => { commit(types.SET_CAT_TOTAL_PAGES, total) },

  setBreadcrumb: ({commit}, breadcrumb) => { commit(types.SET_CAT_BREADCRUMB, breadcrumb) },

  resetState: ({commit}) => { commit(types.SET_RESET_STATE) }
}

const mutations = {
  [types.SET_CAT_ID] (state, id) {
    state.catId = id
  },

  [types.SET_CAT_PUBS] (state, pubs) {
    state.publications = Array.isArray(pubs) && pubs
  },

  [types.SET_CAT_PAGE] (state, page) {
    state.page = parseInt(page)
  },

  [types.SET_CAT_TOTAL_PAGES] (state, total) {
    state.totalPages = total
  },

  [types.SET_CAT_ADS] (state, ads) {
    state.ads = ads
  },

  [types.SET_CAT_TOTAL_PUBS] (state, total) {
    state.totalPubs = total
  },

  [types.SET_CAT_BREADCRUMB] (state, breadcrumb) {
    state.breadcrumb = breadcrumb || []
  },

  [types.SET_RESET_STATE] (state) {
    Object.assign(state, getInitialState())
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/category.js